import { render, staticRenderFns } from "./CzTitle.vue?vue&type=template&id=b24e00c6&scoped=true&"
import script from "./CzTitle.vue?vue&type=script&lang=ts&"
export * from "./CzTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CzTitle.vue?vue&type=style&index=0&id=b24e00c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e00c6",
  null
  
)

export default component.exports